import { queryOptions } from '@tanstack/vue-query'
import { unref, type MaybeRef } from 'vue'
import { personalChatsQueryOptions } from '#entities/chat'
import { getPersonalChat } from '../api/get-personal-chat'

export const getPersonalChatQueryKey = (peerId: MaybeRef<number>) => ['chats', 'personal', peerId]

export const getPersonalChatQueryOptions = (peerId: MaybeRef<number>) =>
  queryOptions({
    queryKey: getPersonalChatQueryKey(peerId),
    queryFn: async ({ client }) => {
      const personalChatsQueryData = client.getQueryData(personalChatsQueryOptions.queryKey)
      const cachedChats = personalChatsQueryData?.pages.flatMap(page => page.data) ?? []
      const queryingChat = cachedChats.find(chat => chat.peer?.id === unref(peerId))

      if (queryingChat) return queryingChat

      return getPersonalChat(unref(peerId))
    },
    staleTime: 60_000,
  })
